{
  /*
SPDX-FileCopyrightText: 2021 City of Tampere

SPDX-License-Identifier: LGPL-2.1-or-later
*/
}

import type { CommonCustomizations } from 'lib-customizations/types'

import theme from './tampere-theme'

const customizations: CommonCustomizations = {
  theme
}

export default customizations
